import { useSafeState } from 'ahooks';
import { useModel } from '@@/exports';
import { queryCustomerDetail } from '@/pages/Mine/My/service';
import { useEffect } from 'react';
import { CustomerDetailType } from '@/interface';

export default function useDefaultCustomer() {
  const [defaultCustomerId, setDefaultCustomerId] = useSafeState<string>();
  const [defaultCustomerInformation, setDefaultCustomerInformation] =
    useSafeState<CustomerDetailType>();

  const { defaultRoom } = useModel('useDefaultRoom', (model) => ({
    defaultRoom: model.defaultRoom,
  }));

  const loadCustomerInformation = async () => {
    const res = await queryCustomerDetail({ roomId: defaultRoom?.roomId });
    if (res?.code === 200) {
      if (res?.rows?.length) {
        setDefaultCustomerId(res.rows[0].sequenceNbr);
        setDefaultCustomerInformation(res.rows[0]);
      }
    }
  };

  useEffect(() => {
    if (defaultRoom?.roomId) {
      loadCustomerInformation();
    }
  }, [defaultRoom]);

  return {
    defaultCustomerId,
    defaultCustomerInformation,
  };
}
